module.exports = __webpack_public_path__ + "img/7.bd3f2f30.png";